import { LazyLoadImage } from "react-lazy-load-image-component";

export default function CurationListItem({ placeItem, mapEmoji, clickEvent, hoverInEvent, hoverOutEvent, topLeftBadge }) {
    const description = placeItem.description
    const images = placeItem.images.map((image) => {
        return <div className={`carousel-item h-full max-w-full w-full`}>
            <LazyLoadImage className="rounded-md h-full w-full object-cover max-w-full" src={image.url} />
        </div>
    })
    return <div 
        className="px-4 py-4 bg-base-200 cursor-pointer hover:bg-base-300 mb-2 flex flex-row gap-4 items-center relative" 
        onClick={clickEvent}
        onMouseOver={() => {
            console.log(`mouse has entered ${placeItem.id}`)
            hoverInEvent?.(placeItem.id)
        }}
        onMouseOut={() => {
            console.log(`mouse has left ${placeItem.id}`)
            hoverOutEvent?.(placeItem.id)
        }}
    >
        {
            images.length > 0 && 
            <div className="carousel rounded-lg h-32 w-32 space-x-4 flex-shrink-0">{images}</div>
        }
        { topLeftBadge && <div className="indicator-item badge badge-accent absolute top-2 left-2 text-lg p-0 rounded-full w-8 h-8 font-titan">
            { topLeftBadge }
            
        </div> }
        {
            images.length === 0 &&
            <div className="w-32 h-16 rounded-lg flex items-center justify-center text-5xl shrink-0">{ placeItem.markerEmoji ?? mapEmoji }</div>
        }
        <div className={``}>
            <div className="top-section w-full py-2">
            <div className="flex justify-between w-full">
                <div className="text-base-content text-xl md:text-2xl font-titan font-bold text-base-content leading-7">{ placeItem.title }</div>
            </div>
            {
                description && <div className="grow text-sm md:text-base self-center text-base-content pt-2">
                    { description }
                </div>
            }
            {
                placeItem.distance && <div className="flex content-center pt-2">
                    <svg className="w-4 h-4 self-center stroke-base-content" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="3" fill="none"><path d="M17.94,54.81a.1.1,0,0,1-.14,0c-1-1.11-11.69-13.23-11.69-21.26,0-9.94,6.5-12.24,11.76-12.24,4.84,0,11.06,2.6,11.06,12.24C28.93,41.84,18.87,53.72,17.94,54.81Z"/><circle cx="17.52" cy="31.38" r="4.75"/><path d="M49.58,34.77a.11.11,0,0,1-.15,0c-.87-1-9.19-10.45-9.19-16.74,0-7.84,5.12-9.65,9.27-9.65,3.81,0,8.71,2,8.71,9.65C58.22,24.52,50.4,33.81,49.58,34.77Z"/><circle cx="49.23" cy="17.32" r="3.75"/><path d="M17.87,54.89a28.73,28.73,0,0,0,3.9.89"/><path d="M24.68,56.07c2.79.12,5.85-.28,7.9-2.08,5.8-5.09,2.89-11.25,6.75-14.71a16.72,16.72,0,0,1,4.93-3" stroke-dasharray="7.8 2.92"/><path d="M45.63,35.8a23,23,0,0,1,3.88-.95"/></svg>
                    <div className="text-sm self-center pl-1 md:text-base text-base-content line-clamp-2 opacity-70">
                        { `${Math.round(placeItem.distance * 100) / 100}km from you` }
                    </div>
                </div>
            }
            </div>
            <div className="bottom-section">
            </div>
        </div>
    </div>;
}
